import { render } from "./hand-6.vue?vue&type=template&id=6cf198c8&scoped=true"
import script from "./hand-6.vue?vue&type=script&lang=js"
export * from "./hand-6.vue?vue&type=script&lang=js"

import "./hand-6.vue?vue&type=style&index=0&id=6cf198c8&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf198c8"]])

export default __exports__